import React, { Component } from 'react';
import { Field } from 'formik';
import { Formik } from 'formik';

import { Button, Col, Form, FormFeedback, FormGroup, Label, Input, Row, Card, CardBody, CardHeader } from 'reactstrap';
import * as Yup from 'yup';
import Postman from '../../utils/service'
import { connect } from 'react-redux'
import { isEmpty } from '../../common/utils'

import { withRouter, Link } from 'react-router-dom'
import { deleteFundingById, getCompanybyName, deleteEmployeeById } from '../../actions/CompanyAction'
import { encodeforspace, decodeforspace } from '../../utils/helper';
import Select from 'react-select'
import ToggleButton from 'react-toggle-button'
import Helmet from 'react-helmet'

import './index.css'

const urlRegExp =  /^(http[s]?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+(\S*)$/;

// /^(?:(http|https)?:\/\/)?(?:[\w-]+\.)+([a-z]|[A-Z]|[0-9]){2,6}$/gi;

const extractFilterData = data => data.filter(item => item.DISTINCT)
  .map(item => ({ value: item.DISTINCT, label: item.DISTINCT }))
class FundingTable extends React.Component {

  deleteFundingById = id => {
    const { deleteFundingById, getCompanybyName, companyName } = this.props
    deleteFundingById(id)
    getCompanybyName(companyName)
  }
  render() {
    const { companyName, data } = this.props

    return (
      <div style={{ marginTop: 35 }}>
        <div className="row" style={{ display: 'flex' }}>
          <div className="col-md-3">
            <h3 id='funding-rounds' >{companyName} Funding</h3>
          </div>
          <div className="col-md-3 offset-md-6 text-right">
            <Link to={`/edit_funding/add`} className="add-btn pull-right">Add</Link>
          </div>
        </div>
        <table className="table table-bordered">
          <thead>
            <tr style={{ backgroundColor: 'rgb(71, 72, 102)', color: 'white' }}>
              <th scope="col">Date</th>
              <th scope="col">Amount</th>
              <th scope="col">Round</th>
              <th scope="col">Lead Investors</th>
              <th scope="col">Reference</th>
              <th scope="col">Operations</th>
            </tr>
          </thead>
          <tbody>
            {isEmpty(data) ? null :
              data.map((item, index) => (
                <tr key={index + 'funding'}>
                  <td>{item.date_created}</td>
                  <td>${item.Amount}</td>
                  <td>{item.Round}</td>
                  <td>{item.LeadInvestors}</td>
                  <td><a href={item.news_url} target="_blank">Article</a></td>
                  <td>
                    <Link to={`/edit_funding/${index}`}>Edit</Link>
                    <a onClick={() => this.deleteFundingById(item.id)} className='delete-btn'>Delete</a>
                  </td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>
    )
  }
}
class EmployeeTable extends React.Component {

  deleteEmployeeById = id => {
    const { deleteEmployeeById, getCompanybyName, companyName } = this.props
    deleteEmployeeById(id)
    getCompanybyName(companyName)
  }
  render() {
    const { companyName, data } = this.props

    return (
      <div style={{ marginTop: 35 }}>
        <div className="row" style={{ display: 'flex' }}>
          <div className="col-md-3">
            <h3 id='funding-rounds' >{companyName} Employee</h3>
          </div>
          <div className="col-md-3 offset-md-6 text-right">
            <Link to={`/edit_employee/add`} className="add-btn pull-right">Add</Link>
          </div>
        </div>
        <table className="table table-bordered">
          <thead>
            <tr style={{ backgroundColor: 'rgb(71, 72, 102)', color: 'white' }}>
              <th scope="col">Name</th>
              <th scope="col">Title</th>
              <th scope="col">Operations</th>
            </tr>
          </thead>
          <tbody>
            {isEmpty(data) ? null :
              data.map((item, index) => (
                <tr key={index + 'funding'}>
                  <td>{item.name}</td>
                  <td>{item.title}</td>
                  <td>
                    <Link to={`/edit_employee/${index}`}>Edit</Link>
                    <a onClick={() => this.deleteEmployeeById(item.id)} className='delete-btn'>Delete</a>
                  </td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>
    )
  }
}

class AddNewCompanyForm extends Component {

  ValidationSchema = Yup.object().shape({
    first_name: Yup.string()
      .required('Required'),
      last_name: Yup.string()
      .required('Required'),
      email: Yup.string()
      .required('Required').email(),
    company_name: Yup.string()
      .required('Required'),
    linkedin_url: Yup.string().required('Required').url(),
    city: Yup.string().required('Required'),
    state: Yup.string().required('Required')
      .test('len', 'Please enter 2 characters valid state code', val => val && val.length === 2),
    country: Yup.string().nullable().required('Required'),
    current_employees: Yup.string().required('Required'),
    last_employees: Yup.string().required('Required'),
    founded: Yup.string().required('Required'),
    job_openings: Yup.string().required('Required'),
    Industry: Yup.string().required('Required'),
    keywords: Yup.string().required('Required'),
    bio: Yup.string().required('Required'),
    total_funding_float: Yup.number().typeError('Must be a number').nullable(),
    estimated_revenues: Yup.number().positive().integer(),
    url: Yup.string()
    .matches(urlRegExp, 'Url is not valid')
    .required('Required'),
    // url: this.props.addNewCompany ?
    //   Yup.string().required('Required').url() /*test('len', 'URL is not matching with your email address',
    //    val => { return val && this.props.user.email.split('@').pop() == val  })*/
    //   : Yup.string()
  });

  constructor(props) {
    super(props)
    let activeTab = 'about';
    if (props.user.email) {

    }
    if (props.addNewCompany) {
      if (props.user.company_id) {
        console.log('testtest2');
        // return;
        // return this.props.history.push(`/`)
      }
    } else if (props.match.params.type == 'funding' || props.match.params.type == 'employee') {
      activeTab = props.match.params.type
    }

    console.log('props.user', props.user)
    this.state = {
      first_name: /*props.user ? props.user.first_name :*/ '',
      last_name: /*props.user ? props.user.last_name :*/ '',
      email: /*props.user ? props.user.email :*/ '',
      error: null,
      company: {},
      activeTab: activeTab,
      countryList: [],
      industryList: [],
      cityList: [],
      stateList: [],
      subIndustryList: [],
      loading: true,
      showCompanySubmisionAd : false,
      showForm: true
    }
  }
  componentDidMount() {
    Postman.getDataForCompanyEditFilter()
      .then(res => {
        const { country, industry } = res.data

        this.setState({
          loading: false,
          countryList: extractFilterData(country),
          industryList: extractFilterData(industry)
        })
      })
    // const { company } = this.props
    // Postman.getCompanyByName(company)
    // .then(res=>{
    //   this.setState({company:res.data})
    // })
  }

  onSubmitUpdate = (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
    Postman.updateCompany(this.props.company.company_name, values)
      .then((res) => {
        this.props.history.push(`/company/` + encodeforspace(this.props.company.company_name))
      }
      )
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          return window.location = '/logout'
        }
        this.props.history.push('/')
      })
  }

  onSubmitCreate = (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
    const company = { ...values }
    Postman.createNewCompany(this.props.company.company_name, { company })
      .then((res) => {
        // alert('Please see the email confirmation sent to you. You may need to check your spam folder.');
        // toast.notify('Your request has been submmited.', { type: 'success', 'title': 'Success!' })
        this.setState({showForm: false, showCompanySubmisionAd: true})
        if(typeof window != 'undefined') window.scrollTo(0, 0);


      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {

        // alert('Your request has been submmited.');

          return window.location = '/logout'
        }
        this.props.history.push('/')
        status = error.response.status
        if (status == 409 || status == 404) {
        alert(error.response.data.message);

          // toast.notify(error.response.data.message, { type: 'error', 'title': 'Error!' })
        }
      })
  }

  changeTab = (type) => {
    this.setState({ activeTab: type })
    this.props.getCompanybyName(this.props.company.company_name)
    this.props.history.push('/edit_company/' + encodeforspace(this.props.company.company_name) + '/' + type)
  }

  handleIndustryChange = (value) => {
    const { field, form } = this.props
    form.setFieldValue(field.name, value)
  }

  SelectField = (FieldProps) => {
    return (
      <Select
        className="basic-single"
        classNamePrefix="select"
        isClearable={true}
        isSearchable={true}
        options={FieldProps.options}
        placeholder={FieldProps.placeholder}
        // {...FieldProps.field}

        value={FieldProps.field.value ? { label: FieldProps.field.value, value: FieldProps.field.value } : null}

        onChange={option => FieldProps.form.setFieldValue(FieldProps.field.name, option.value)}
      />
    )
  }

  ToggleButtonField = (FieldProps) => {
    return (
      <ToggleButton
        value={FieldProps.value}
        // onToggle={(value) => {
        //   console.log('test',value)
        // }}
        onToggle={value => FieldProps.form.setFieldValue(FieldProps.field.name, !value)}
      />
    )
  }

  render() {

    const { company } = this.props;

    let {

      url,
      linkedin_url,
      current_employees,
      last_employees,
      company_name,
      city,
      state,
      country,
      bio,
      founded,
      Industry,
      estimated_revenues,
      job_openings,
      keywords,
      LeadInvestors,
      valuation,
      total_funding_float,
      twitter_username,
      show_revenue,
    } = company

    let first_name = this.state.first_name
    let last_name = this.state.last_name
    let email = this.state.email


    if (!show_revenue && estimated_revenues <= 0) {
      estimated_revenues = 1
    }

    if (!last_employees) {
      last_employees = ' '
    }

    if (!company.url) {
      url = ''
      linkedin_url = '';
      current_employees = '';
      last_employees = '';
      company_name = '';
      city = '';
      state = '';
      country = '';
      bio = '';
      founded = '';
      Industry = '';
      estimated_revenues = '';
      job_openings = '';
      keywords = '';
      LeadInvestors = '';
      valuation = '';
      total_funding_float = '';
      twitter_username = '';
      show_revenue = 0;
    }
    const { loading } = this.state
    // if (loading) return null
    if(this.state.showForm) {
      return (
        <React.Fragment >
          {/* <ToastContainer align={"right"} position={"bottom"} id="toast-container" /> */}
          {!this.props.addNewCompany &&
            <ul className="nav nav-tabs">
              <li onClick={() => { this.changeTab('about') }} className={'nav-item'}><a className={"nav-link " + (this.state.activeTab == 'about' ? 'active' : '')} data-toggle="tab" >About {company.company_name}</a></li>
              <li onClick={() => { this.changeTab('funding') }} className={'nav-item'}><a className={"nav-link " + (this.state.activeTab == 'funding' ? 'active' : '')} data-toggle="tab" >{company.company_name} Funding</a></li>
              {/* <li onClick={() => { this.changeTab('employee') }} className={'nav-item'}><a className={"nav-link " + (this.state.activeTab == 'employee' ? 'active' : '')} data-toggle="tab" >{company.company_name} Employee</a></li> */}
            </ul>
          }

          <div className="tab-content">
            <div id="about" className={(this.state.activeTab == 'about' ? 'active show' : '') + ' tab-pane fade'} style={{ marginTop: '35px' }}>
              <div className="row" style={{ display: 'flex' }}>
                <div className="col-md-12 pb-4">
                  <h3 id='funding-rounds' >{this.props.addNewCompany ? 'Company Details' : 'Update Company Profile'} </h3>
                </div>
              </div>
              <div style={{ marginLeft: 0 }}>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    first_name,
                    last_name,
                    email,
                    url,
                    linkedin_url,
                    current_employees,
                    last_employees,
                    company_name,
                    city,
                    state,
                    country,
                    bio,
                    founded,
                    Industry,
                    estimated_revenues,
                    job_openings,
                    keywords,
                    LeadInvestors,
                    valuation,
                    total_funding_float,
                    twitter_username,
                    show_revenue
                  }}
                  validationSchema={this.ValidationSchema}
                  onSubmit={this.props.addNewCompany ? this.onSubmitCreate : this.onSubmitUpdate}
                >
                  {({ errors, touched, values, handleChange, handleSubmit, isValid, setTouched }) => (
                    <Form onSubmit={handleSubmit} noValidate name='subscribeForm' style={{ width: "100%" }}>
                      <Row>
                        <Col lg={6}>
                          <FormGroup className="custom-form-group row">
                            <Col lg={4}>
                              <Label className="custom-label">First Name:</Label>
                            </Col>
                            <Col lg={8}>
                              <Input type="text"
                                name="first_name"
                                id="first_name"
                                placeholder=""
                                autoFocus={false}
                                onChange={handleChange}
                                required
                                value={values.first_name} />
                              <FormFeedback>{errors.first_name}</FormFeedback>
                            </Col>
                          </FormGroup>

                          <FormGroup className="custom-form-group row">
                            <Col lg={4}>
                              <Label className="custom-label">Last Name:</Label>
                            </Col>
                            <Col lg={8}>
                              <Input type="text"
                                name="last_name"
                                id="last_name"
                                placeholder=""
                                autoFocus={false}
                                onChange={handleChange}
                                required
                                value={values.last_name} />
                              <FormFeedback>{errors.last_name}</FormFeedback>
                            </Col>
                          </FormGroup>

                          <FormGroup className="custom-form-group row">
                            <Col lg={4}>
                              <Label className="custom-label">Email:</Label>
                            </Col>
                            <Col lg={8}>
                              <Input type="text"
                                name="email"
                                id="email"
                                placeholder=""
                                autoFocus={false}
                                onChange={handleChange}
                                required
                                value={values.email} />
                              <FormFeedback>{errors.email}</FormFeedback>
                            </Col>
                          </FormGroup>




                          <FormGroup className="custom-form-group row">
                            <Col lg={4}>
                              <Label className="custom-label">Company Name:</Label>
                            </Col>
                            <Col lg={8}>
                              <Input type="text"
                                name="company_name"
                                id="company_name"
                                placeholder=""
                                autoFocus={false}
                                onChange={handleChange}
                                required
                                value={values.company_name} />
                              <FormFeedback>{errors.company_name}</FormFeedback>
                            </Col>
                          </FormGroup>
                          {this.props.addNewCompany &&
                            <FormGroup className="custom-form-group row">
                              <Col lg={4}>
                                <Label className="custom-label">Company Website URL:</Label>
                              </Col>
                              <Col lg={8}>
                                <Input type="text"
                                  name="url"
                                  id="url"
                                  placeholder=""
                                  autoFocus={false}
                                  onChange={handleChange}
                                  required
                                  value={values.url} />
                                <FormFeedback>{errors.url}</FormFeedback>
                              </Col>
                            </FormGroup>}
                          <FormGroup className="custom-form-group row">
                            <Col lg={4}>
                              <Label className="custom-label">Company Linkedin URL:</Label>
                            </Col>
                            <Col lg={8}>
                              <Input type="text"
                                name="linkedin_url"
                                id="linkedin_url"
                                placeholder=""
                                autoFocus={false}
                                onChange={handleChange}
                                required
                                value={values.linkedin_url} />
                              <FormFeedback>{errors.linkedin_url}</FormFeedback>
                            </Col>
                          </FormGroup>
                          <FormGroup className="custom-form-group row">
                            <Col lg={4}><Label className="custom-label">City:</Label></Col>
                            <Col lg={8}>

                              <Input type="text"
                                name="city"
                                id="city"
                                placeholder=""
                                autoFocus={false}
                                onChange={handleChange}
                                required
                                value={values.city} />
                              <FormFeedback>{errors.city}</FormFeedback>
                            </Col>
                          </FormGroup>
                          <FormGroup className="custom-form-group row">
                            <Col lg={4}><Label className="custom-label">State:</Label></Col>
                            <Col lg={8}>
                              <Input type="text"
                                name="state"
                                id="state"
                                placeholder=""
                                autoFocus={false}
                                onChange={handleChange}
                                required
                                value={values.state} />
                              <FormFeedback>{errors.state}</FormFeedback>
                            </Col>
                          </FormGroup>
                          <FormGroup className="custom-form-group row">
                            <Col lg={4}><Label className="custom-label">Country:</Label></Col>
                            <Col lg={8}>
                              <Field placeholder={'Select Country'} name='country' options={this.state.countryList} component={this.SelectField} value={values.country} />

                              <FormFeedback>{errors.country}</FormFeedback>
                            </Col>
                          </FormGroup>
                          <FormGroup className="custom-form-group row">
                            <Col lg={4}><Label className="custom-label">Current Employee Count:</Label></Col>
                            <Col lg={8}>
                              <Input type="text"
                                name="current_employees"
                                id="current_employees"
                                placeholder=""
                                autoFocus={false}
                                onChange={handleChange}
                                required
                                value={values.current_employees} />
                              <FormFeedback>{errors.current_employees}</FormFeedback>
                            </Col>
                          </FormGroup>
                          <FormGroup className="custom-form-group row">
                            <Col lg={4}><Label className="custom-label">Employee Count 12 months ago:</Label></Col>
                            <Col lg={8}>
                              <Input type="text"
                                name="last_employees"
                                id="last_employees"
                                placeholder=""
                                autoFocus={false}
                                onChange={handleChange}
                                required
                                value={values.last_employees} />
                              <FormFeedback>{errors.last_employees}</FormFeedback>
                            </Col>
                          </FormGroup>
                          <FormGroup className="custom-form-group row">
                            <Col lg={4}><Label className="custom-label">Founded:</Label></Col>
                            <Col lg={8}>
                              <Input type="text"
                                name="founded"
                                id="founded"
                                placeholder=""
                                autoFocus={false}
                                onChange={handleChange}
                                required
                                value={values.founded} />
                              <FormFeedback>{errors.founded}</FormFeedback>
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col lg={6}>


                          {/* <FormGroup className="custom-form-group row">
                            <Col lg={4}><Label className="custom-label">Show Company Revenue</Label></Col>
                            <Col lg={8}>
                              <Field name='show_revenue' options={this.state.countryList} component={this.ToggleButtonField} value={values.show_revenue} />
                            </Col>
                          </FormGroup> */}
                          {values.show_revenue ? <FormGroup className="custom-form-group row">
                            <Col lg={4}><Label className="custom-label">Revenues (trailing 12 mths):</Label></Col>
                            <Col lg={8}>
                              <Input type="text"
                                name="estimated_revenues"
                                id="estimated_revenues"
                                placeholder=""
                                autoFocus={false}
                                onChange={handleChange}
                                required
                                value={values.estimated_revenues} />
                              <FormFeedback>{errors.estimated_revenues}</FormFeedback>
                            </Col>
                          </FormGroup> : ''}
                          <FormGroup className="custom-form-group row">
                            <Col lg={4}><Label className="custom-label">Job openings:</Label></Col>
                            <Col lg={8}>
                              <Input type="text"
                                name="job_openings"
                                id="job_openings"
                                placeholder=""
                                autoFocus={false}
                                onChange={handleChange}
                                required
                                value={values.job_openings} />
                              <FormFeedback>{errors.job_openings}</FormFeedback>
                            </Col>
                          </FormGroup>


                          <FormGroup className="custom-form-group row">
                            <Col lg={4}><Label className="custom-label">Industry:</Label></Col>
                            <Col lg={8}>
                              <Field placeholder={'Select Industry'} name='Industry' options={this.state.industryList} component={this.SelectField} value={values.Industry} required />
                              <FormFeedback>{errors.Industry}</FormFeedback>
                            </Col>
                          </FormGroup>
                          <FormGroup className="custom-form-group row">
                            <Col lg={4}><Label className="custom-label">Keywords:</Label></Col>
                            <Col lg={8}>
                              <Input type="text"
                                name="keywords"
                                id="keywords"
                                placeholder=""
                                autoFocus={false}
                                onChange={handleChange}
                                required
                                value={values.keywords} />
                              <FormFeedback>{errors.keywords}</FormFeedback>
                            </Col>
                          </FormGroup>
                          <FormGroup className="custom-form-group row">
                            <Col lg={4}><Label className="custom-label">Twitter Username:</Label></Col>
                            <Col lg={8}>
                              <Input type="text"
                                name="twitter_username"
                                id="twitter_username"
                                placeholder=""
                                autoFocus={false}
                                onChange={handleChange}
                                required
                                value={values.twitter_username} />
                              <FormFeedback>{errors.twitter_username}</FormFeedback>
                            </Col>
                          </FormGroup>
                          <FormGroup className="custom-form-group row">
                            <Col lg={4}><Label className="custom-label">Lead Investors:</Label></Col>
                            <Col lg={8}>
                              <Input type="text"
                                name="LeadInvestors"
                                id="LeadInvestors"
                                placeholder=""
                                autoFocus={false}
                                onChange={handleChange}
                                required
                                value={values.LeadInvestors} />
                              <FormFeedback>{errors.LeadInvestors}</FormFeedback>
                            </Col>
                          </FormGroup>
                          <FormGroup className="custom-form-group row" >
                            <Col lg={4}><Label className="custom-label">Valuation:</Label></Col>
                            <Col lg={8}>
                              <Input type="text"
                                name="valuation"
                                id="valuation"
                                placeholder=""
                                autoFocus={false}
                                onChange={handleChange}
                                required
                                value={values.valuation == 0 ? '' : values.valuation} />
                              <FormFeedback>{errors.valuation}</FormFeedback>
                            </Col>
                          </FormGroup>
                          <FormGroup className="custom-form-group row">
                            <Col lg={4}><Label className="custom-label">Total funding:</Label></Col>
                            <Col lg={8}>
                              <Input type="text"
                                name="total_funding_float"
                                id="total_funding_float"
                                placeholder=""
                                autoFocus={false}
                                onChange={handleChange}
                                required
                                value={values.total_funding_float == 0 ? '' : values.total_funding_float} />
                              <FormFeedback>{errors.total_funding_float}</FormFeedback>
                            </Col>
                          </FormGroup>
                          <FormGroup className="custom-form-group row" style={{ alignItems: "baseline" }}>
                            <Col lg={4}><Label className="custom-label">Description:</Label></Col>
                            <Col lg={8}>
                              <Input type="textarea"
                                name="bio"
                                id="bio"
                                placeholder=""
                                autoFocus={false}
                                onChange={handleChange}
                                required
                                rows={8}
                                value={values.bio} />
                              <FormFeedback>{errors.bio}</FormFeedback>
                            </Col>
                          </FormGroup>
                        </Col>
                      </Row>
                      <FormGroup className="text-right">
                        <Button
                          // onClick={() => this.touchAll(setTouched, errors)}
                          style={{ width: 150 }}
                          type="submit" color="success" className="mr-1">Save</Button>
                      </FormGroup>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
            <div id="funding" className={(this.state.activeTab == 'funding' ? 'active show' : '') + ' tab-pane fade'}>
              <FundingTable data={company.FundingCompanyPresses} companyName={company.company_name} {...this.props} />
            </div>
            {/* <div id="employee" className={(this.state.activeTab == 'employee' ? 'active show' : '') + ' tab-pane fade'}>
              <EmployeeTable data={company.executive_contacts} companyName={company.company_name} {...this.props} />
            </div> */}
          </div>


        </React.Fragment>
      );
          }

    if(this.state.showCompanySubmisionAd){
      return (
        <React.Fragment >
          <Card>
                    {/* <CardHeader className='cardHeader'>
                        <h1 style={{ color: '#474866', fontSize: 38, marginBottom: 0, textAlign: 'center' }}>Company Registeration Request Submitted</h1>
                    </CardHeader> */}
                    <CardBody style={{marginTop:'0px'}}>
                        <h2 style={{fontSize:'30px'}}>Add Your Company</h2>
                        <p style={{fontSize: "20px"}}>

                        ~If you are looking to add your company to Growjo with a followed link along with a link to our <Link to="/recently_added">Recently Added</Link> page, then it costs $200. You can pay via stripe <a href="https://buy.stripe.com/6oEaF4cqQ5Dp5ZS9AH" target='_blank'>here</a>.</p>

                        <h2  style={{fontSize:'30px'}}>Advertise on Your Competitors Profile</h2>
                        <p style={{fontSize: "20px"}}>~If you are looking to be listed at the top of your competitor's "Competitors" section it costs $500/year which includes a followed link and your own CTA.  Please email us at
                            <a href="mailto:subscribe@growjo.com"> subscribe@growjo.com </a> </p>


                    </CardBody>
                </Card>
        </React.Fragment>

      )
    }
  }
};

class AddNewCompany extends Component {
  constructor(props) {
    super(props)
    if (!this.props.company.company_name && !this.props.addNewCompany) {
      this.props.getCompanybyName(decodeforspace(props.match.params.name))
    }

    this.state = {
    }
  }
  componentDidMount() {
    const { company } = this.props
    //    if ( isEmpty(company) ) this.props.history.push('/')

  }

  render() {
    const { company, isEditableCompany } = this.props
    // if ((!company.url || !isEditableCompany) && !this.props.addNewCompany) return null
    return (
      <React.Fragment><Helmet>
        <title>Growjo - {this.props.addNewCompany ? 'Add Your Company' : 'Update Company'}</title>
      </Helmet>
        <div className="animated fadeIn" style={{ height: "100%" }}>
          <Card style={{ height: "100%", margin: 0 }}>
            <CardHeader><h1 className="header-text">{this.props.addNewCompany ? 'Add Your Company' : 'Edit Company'}</h1></CardHeader>

            <CardBody style={{ padding: 30, paddingTop: 20 }}>
              <AddNewCompanyForm company={this.props.company} {...this.props} />
            </CardBody>
          </Card>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  let isEditableCompany = true;
  if (state.company.data.url && state.auth.isAuthenticated && state.auth.user.email.indexOf('@' + state.company.data.url) < 0) {
    isEditableCompany = false
  }

  return {
    company: state.company.data,
    user: state.auth.user,
    isEditableCompany: isEditableCompany
  }
}

export default withRouter(connect(mapStateToProps, { deleteFundingById, deleteEmployeeById, getCompanybyName })(AddNewCompany));



// WEBPACK FOOTER //
// ./client/src/views/AddNewCompany/index.js